import React from 'react';

export const OaktreeLogo = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Oak Tree Icon */}
    <rect width="48" height="48" rx="10" fill="#1E3A8A"/>
    {/* Tree Crown */}
    <ellipse cx="24" cy="18" rx="12" ry="10" fill="#FFFFFF"/>
    <ellipse cx="18" cy="20" rx="8" ry="7" fill="#FFFFFF"/>
    <ellipse cx="30" cy="20" rx="8" ry="7" fill="#FFFFFF"/>
    <ellipse cx="24" cy="14" rx="9" ry="8" fill="#FFFFFF"/>
    {/* Tree Trunk */}
    <rect x="21" y="26" width="6" height="12" rx="1" fill="#FFFFFF"/>
    {/* Base */}
    <ellipse cx="24" cy="38" rx="8" ry="2" fill="#FFFFFF" opacity="0.6"/>
  </svg>
);

export const OaktreeLogoText = ({ className = '' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <OaktreeLogo size={36} />
    <div className="flex flex-col leading-none">
      <span className="text-lg font-bold tracking-tight text-[#1E3A8A]" style={{ fontFamily: 'Manrope, sans-serif' }}>
        OAKTREE
      </span>
      <span className="text-xs font-medium text-[#2563EB]" style={{ fontFamily: 'Manrope, sans-serif' }}>
        Recruit
      </span>
    </div>
  </div>
);

export default OaktreeLogo;
